export default class Tide {
  constructor(options = {}) {
    const { time, type } = options

    this.time = time || null
    this.type = type || null
  }
}
